import { Amplify } from 'aws-amplify';
const awsmobile = {
    'aws_project_region': 'us-east-1',
    'aws_cognito_region': 'us-east-1',
    'aws_user_pools_id': 'us-east-1_kysBquqEK',
    'aws_user_pools_web_client_id': '4fg2bf7f5m6rfs30ovig76hnq2',
    'neta_super_admin_user_sub':'d4885478-e0c1-7050-3abb-957226a49e21',
    'oauth': {},
    'endpoints': [
        {
            name: 'backend-api',
            endpoint: 'https://prod.api.daf.netafoundation.org',
            custom_header: async () => {
        try {
          const currentUser = await Amplify.currentSession();
          // If there is a user that is logged in
          if (currentUser) {
            const token = currentUser.idToken.jwtToken;
            return { Authorization: token };
          }
        } catch (error) {
          if (error === 'No current user') {
            // Get guest user (not logged in)
            const currentUser = await Amplify.currentCredentials();
            if (currentUser) {
              const token = currentUser.sessionToken;
              return { Authorization: token };
            }
          }
        }
      },
    },
  ],
    'Analytics': {
        disabled: true
    }
};

export default awsmobile;
